export const VIEW_CTX = {
  vehicles: 'vehicle',
  substituteConductor: 'substitute-conductor',
  addictive: 'addictive',
  searchPermissionary: 'search-permissionary',
  searchActualPermissionary: 'search-actual-permissionary',
  searchSubstitutePermissionary: 'search-substitute-permissionary',
  searchRequest: 'search-request',
};

export const FORMATTED = {
  document: 'document',
  date: 'date',
  currency: 'currency',
  //
};
